module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal login-form",
    attrs: {
      "id": "login-form",
      "action": _vm.loginUrl
    },
    on: {
      "submit": _vm.submit
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Log In")]), _vm._v(" "), (_vm.loginAlert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.loginAlert.class
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.loginAlert.msg) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.passwordResetRequest
    }
  }, [_vm._v("I forgot my password")])])]), _vm._v(" "), _c('ModalDialog', {
    attrs: {
      "title": "Password Reset Request",
      "modal-visible": _vm.resetRequest.visible,
      "confirm-button-text": "Submit"
    },
    on: {
      "confirm": _vm.submitResetRequest,
      "closeModal": function($event) {
        _vm.resetRequest.visible = false
      }
    }
  }, [_c('FormGroup', {
    attrs: {
      "label": "Your Email",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resetRequest.email),
      expression: "resetRequest.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.resetRequest.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resetRequest.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.resetAlert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.resetAlert.class
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.resetAlert.msg) + "\n\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('spinner', {
    attrs: {
      "spinner-visible": _vm.spinnerVisible
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-user-circle-o fa-5x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Username/Email"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a525390"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 167
// module chunks = 1